// Add your custom JS here.
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';

// make Masonry a jQuery plugin
jQueryBridget('masonry', Masonry, $);
// now you can use $().masonry()

$(document).ready(function() {
	// Extend mobile menu to show page shim and a fixed page when open
	$('.navbar-toggler').on('click', () => {
		$('body').toggleClass('mobile-menu-open');
	});

	// Remove classes from mobile menuin desktop window sizes
	$(window).on('resize', () => {
		const docWidth = $(document).width();

		if (docWidth > 991) {
			$('body').removeClass('mobile-menu-open');
			$('#navbarNavDropdown').removeClass('show');
			$('.navbar-toggler').addClass('collapsed').attr('aria-expanded', false);
		}

		// Close search modal on resize
		const myModalEl = $('#mobile-filter-modal');

		const modal = understrap.Modal.getInstance(myModalEl);
		modal.hide();
	});

	// Turn mobile search popular posts into an accordion
	$(".btn").data("data-bs-target", "#mobile-filter-modal").on("click", () => {
		$(".modal .widget.popular-posts.wpp-ajax").addClass("js-accordion");
		$(".modal .widget.popular-posts.wpp-ajax .wp-block-heading").addClass("position-relative");
		$(".js-accordion").accordion({
			active: false,
	     	collapsible: true,
	     	icons: {},
	     	heightStyle: "content"
    	});
	});

	// Wait till all images are loaded to initialize the masonry layout
	$(window).load(() => {
		// Initialize masonry layout on image collage component
		$('.js-image-collage').masonry({
	  		columnWidth: '.grid-sizer',
	  		// gutter: 10,
	  		itemSelector: '.grid-item', // use a separate class for itemSelector, other than .col-
	  		percentPosition: true
		});
	});

    $(".dropdown").hover(function() {
        $('.dropdown-menu', this).not('.in .dropdown-menu').stop(true,true).delay(200).slideDown("400");
        $(this).toggleClass('open');        
    }, function() {
        $('.dropdown-menu', this).not('.in .dropdown-menu').stop(true,true).delay(200).slideUp("400");
        $(this).toggleClass('open');       
    });

	// Initialize accordion content
	$(".js-accordion").accordion({
		active: false,
     	collapsible: true,
     	icons: {},
     	heightStyle: "content"
    });
    // Initialize accordion content end

	// Carousel inits
	$('.js-homepage-hero-carousel').slick({
		arrows: false,
		autoplay: true,
  		autoplaySpeed: 5500,
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	$('.js-header-category-carousel').slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		draggable: false,
		speed: 3000,
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		variableWidth: true,
	})

	$('.js-image-carousel').slick({
		arrows: false,
		autoplay: true,
  		autoplaySpeed: 5500,
  		dots: false,
		infinite: true,
		slidesToShow: 6,
		slidesToScroll: 1,
		speed: 500,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
		    		slidesToShow: 4,
				}
		    },
			{
				breakpoint: 991,
				settings: {
		    		slidesToShow: 2,
				}
		    },
		    {
				breakpoint: 767,
				settings: {
		    		slidesToShow: 1,
				}
		    }
		]
	});

	$('.js-review-carousel').slick({
		arrows: false,
		autoplay: true,
  		autoplaySpeed: 5500,
  		dots: false,
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		speed: 500,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
		    		slidesToShow: 4,
				}
		    },
			{
				breakpoint: 991,
				settings: {
		    		slidesToShow: 2,
				}
		    },
		    {
				breakpoint: 767,
				settings: {
		    		slidesToShow: 1,
				}
		    }
		]
	});

	$('.js-full-width-carousel').slick({
		arrows: false,
		autoplay: false,
  		autoplaySpeed: 5500,
  		dots: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 500,
	});

	$('.js-resource-carousel').slick({
		arrows: false,
		asNavFor: '.js-resource-nav-carousel',
		autoplay: false,
  		dots: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 500,
	});

	$('.js-resource-nav-carousel').slick({
		arrows: true,
		asNavFor: '.js-resource-carousel',
		autoplay: false,
		centerPadding: 0,
  		dots: false,
  		focusOnSelect: true,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		speed: 500,
		responsive: [
		    {
				breakpoint: 767,
				settings: {
		    		slidesToShow: 1,
				}
		    }
		]
	});

	$('.js-jobs-carousel').slick({
		arrows: true,
		infinite: true,
		slidesToShow: 3,
		speed: 500,
		responsive: [
		    {
				breakpoint: 991,
				settings: {
		    		slidesToShow: 2,
				}
		    },
		    {
				breakpoint: 767,
				settings: {
					//dots: true,
		    		slidesToShow: 1,
				}
		    }
		]
	});

	$('.js-homepage-hero-carousel').show();
	$('.js-image-carousel.slick-slider').fadeIn(600, 'swing');
	$('.js-full-width-carousel').show();
	$('.js-resource-carousel').show();
	$('.js-jobs-carousel').animate({opacity: 1}, 1000);
	$('.js-resource-carousel').fadeIn(600, 'swing');
	$('.js-header-category-carousel').animate({opacity: 1}, 1000);
	$('.js-review-carousel').show();
	// Carousel inits end

	/* TODO - Find a way to make a way for multiple components
	to be on the page and have unique IDs */
	// Modal functionality
	$("[data-toggle='modal']").on('click', (e) => {
		const target = $(e.target).attr('data-target');

		$(target).modal('show');
	});

	$('.js-modal-close').on('click', (e) => {
		$(e.target).parents('.modal').modal('hide');
	});
});
